import { TranslateService } from '@ngx-translate/core';
import { TableColumn } from '../components/table/table.component';
import { IEmployeeListItem } from '../interfaces/IEmployeeListItem';
import { TableInputFieldComponent } from '../components/table-input-field/table-input-field.component';
import { TableInputFieldVariant } from '../enums/TableInputFieldVariant.enum';
import { IFilterField } from '../interfaces/IFilterField';

export function getEmployeePickerConfig(translateService: TranslateService): TableColumn<IEmployeeListItem>[] {
  return [
    {
      name: 'shared.picker.employee.column.name',
      id: true,
      selector: 'scdName',
      minWidth: '150px',
      filterable: true,
      sortable: true,
      filterType: 'search',
      row: (row: IEmployeeListItem) => row.scdName,
    },
    {
      name: 'shared.picker.employee.column.contractType',
      sortable: true,
      selector: 'contractTypeName',
      filterable: true,
      filterType: 'search',
      filterDisplayFn: (value: string) => translateService.instant(`employees.contractTypes.${value.toLowerCase()}`) as string,
      row: (row: IEmployeeListItem) => row.contractTypeName,
    },
    {
      name: 'shared.picker.employee.column.resigned',
      selector: 'retired',
      filterable: true,
      component: TableInputFieldComponent,
      componentInit: (instance: TableInputFieldComponent<boolean>, row: IEmployeeListItem) => {
        instance.rowValue = row.supRetire ? new Date().getTime() >= new Date(row.supRetire).getTime() : false;
        instance.disabled = true;
        instance.inputVariant = TableInputFieldVariant.Checkbox;
      },
    },
    {
      name: 'shared.picker.employee.column.group',
      sortable: true,
      selector: 'groupName',
      filterable: true,
      filterType: 'search',
      row: (row: IEmployeeListItem) => row.groupName,
    },
    {
      name: 'shared.picker.employee.column.team',
      sortable: true,
      selector: 'teamName',
      filterable: true,
      filterType: 'search',
      row: (row: IEmployeeListItem) => row.teamName,
    },
    {
      name: 'shared.picker.employee.column.orgTeam',
      sortable: true,
      selector: 'orgTeamName',
      filterable: true,
      filterType: 'search',
      row: (row: IEmployeeListItem) => row.orgTeamName,
    },
  ];
}

export const employeePickerFilterFields: IFilterField[] = [
  { key: 'id', displayName: 'default.id', isSelected: true },
  { key: 'scdName', displayName: 'employees.scdName', isSelected: true },
  { key: 'groupName', displayName: 'employees.groupName', isSelected: true },
  { key: 'teamName', displayName: 'employees.teamName', isSelected: true },
  { key: 'orgTeamName', displayName: 'employees.orgTeamName', isSelected: true },
];
